import { Box } from '@chakra-ui/react'
import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'

import { LoadingFailedAlert } from '@/components/LoadingFailedAlert'
import { WithAuth } from '@/hoc/WithAuth'
import type { WizardVehicleAdditionalData } from 'BrokerTsLib/src/dtos'
import { Loading } from '../../../components/Loading'
import { Note } from '../../../components/Note'
import { Steps } from '../../../components/Steps/Steps'
import { WizzardHeader } from '../../../components/WizzardHeader/WizzardHeader'
import { Step3 } from '../../../containers/steps/vehicle/Step3'
import { useInsuranceParams } from '../../../context/InsuranceParamsProvider'
import { QuotesProvider } from '../../../context/QuotesContext'
import { SelectedQuoteProvider } from '../../../context/SelectedQuoteContext'
import { SidebarProvider } from '../../../context/SidebarContext'
import { StepsProvider } from '../../../context/StepsContext'
import { WizzardHeaderProvider } from '../../../context/WizzardHeaderContext'
import { useGetAdditionalData } from '../../../hooks/useWizard'
import { PageWrapper } from '../../../layouts/components/PageWrapper'
import { Sidebar } from '../../../layouts/components/Sidebar'
import PoleasImportSummary from './PoleasImportSummary'

export const Step3Sections = {
  vozidlo: 1,
  pojistnik: 2,
  drzitel: 3,
  vlastnik: 4,
  adresa: 5,
  vinkulant: 6,
  klient: 7
} as const

export type Step3Sections = typeof Step3Sections[keyof typeof Step3Sections]

const Step3PageComponent = () => {
  const navigate = useNavigate()
  const [noteText, setNoteText] = useState<string | undefined>(undefined)

  const { insuranceParams, insuranceParamsId: paramsId, isLoadingData, isFetchingData, error } = useInsuranceParams()
  const { isLoading: isLoadingFormData, data: formData, refetch: refetchFormData } = useGetAdditionalData(paramsId!, {
    enabled: false,
    cacheTime: 0,
  })

  const data = formData?.data as WizardVehicleAdditionalData

  useEffect(() => {
    if (!insuranceParams) return

    if (!insuranceParams.generalParams.selectedOfferId && !isFetchingData) {
      navigate(`/steps/2/${paramsId}`)
      return
    }

    refetchFormData()
  }, [insuranceParams, isFetchingData])

  const handleCreateNote = () => {
    setNoteText('Nová poznámka')
  }

  return (
    <StepsProvider currentStepId={3}>
      <SidebarProvider>
        <WizzardHeaderProvider>
          <QuotesProvider>
            {isLoadingData && <Loading large={true} />}
            {!isLoadingData && error && <LoadingFailedAlert />}
            {(insuranceParams) &&
                            <SelectedQuoteProvider>
                              <PageWrapper
                                steps={<Steps />}
                                header={<WizzardHeader onCreateNote={handleCreateNote} />}
                                sidebar={<Sidebar />}
                                contentHeader={<PoleasImportSummary />}
                                contentProps={{
                                  sx: {
                                    pt: { base: 0, md: 0 },
                                  },
                                }}
                              >
                                {noteText && noteText !== '' && (
                                  <Note
                                    date="11.10.2021 14:35"
                                    text={noteText}
                                    onChange={(text) => setNoteText(text)}
                                  />
                                )}

                                <Box sx={{ pt: { base: 0, md: !noteText ? 8 : 0 } }}>
                                  {isLoadingFormData && <Loading large={true} />}
                                  {!isLoadingFormData && data &&
                                            <Step3 data={data} />
                                  }
                                </Box>
                              </PageWrapper>
                            </SelectedQuoteProvider>
            }
          </QuotesProvider>
        </WizzardHeaderProvider>
      </SidebarProvider>
    </StepsProvider>
  )
}

export const Step3Page = WithAuth(Step3PageComponent)